import React from 'react';
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import ListItemText from "@mui/material/ListItemText";

const ListDocuments = (
    {
        documents = []
    }
) => {
    return (
        <>
            {documents.map((document, i) =>
                <ListItemButton
                    component="a"
                    href={`container/${document.container.id}/show`}
                    target="_blank"
                    key={i}
                >
                    <ListItemIcon>
                        <LibraryBooksIcon/>
                    </ListItemIcon>
                    <ListItemText primary={document.title}/>
                </ListItemButton>
            )}
        </>
    );
};

export default ListDocuments;
